<template>
    <data-view :tableColumns="tableColumns" :tableData="items" :actionButtons="actionButtons" titleKey="documentName"
        @sortChanged="event => emit('sortChanged', event)" @loadMore="emit('loadMore')">
        <template #col-start_date="{ row }">
                {{  renderDate(row.start_date)}}
        </template>
        <template #col-end_date="{ row }">
                {{  renderDate(row.end_date)}}
        </template>
        <template #col-statusName="{ row }">
            <vs-chip :color="row.statusColor">
                {{ $t(row.statusName) | capitalize }}
            </vs-chip>
        </template>
        <template #col-active_frequency="{ row }">
            <vs-chip :color="row.active_frequency == 1 ? 'success' : 'danger'">
                {{ $t(row.active_frequency == 1 ? 'active' : 'disabled') | capitalize }}
            </vs-chip>
        </template>
    </data-view>
</template>

<script setup>
import { ref } from 'vue'
import DataView from '@/views/app/components/DataView'
import { renderDate } from '@/utils/helpers'

const emit = defineEmits(['sortChanged', 'loadMore', 'details'])

const props = defineProps({
    items: { type: Array, default: () => ([]) }
})

const tableColumns = ref([
    { key: 'documentName', label: 'name', sortable: false },
    { key: 'start_date', label: 'start_date', sortable: false },
    { key: 'end_date', label: 'end_date', sortable: false },
    { key: 'frequencyName', label: 'frequency', sortable: false },
    { key: 'statusName', label: 'status', sortable: false },
    { key: 'active_frequency', label: 'automatic', sortable: false },
])

const actionButtons = ref([
    { text: 'details', icon: 'ArrowRightCircleIcon', color: 'primary', permissions:['IU Repse'], onClick: row => emit('details', row) }
])


</script>
